.indicator {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
}
